<template>
    <div class="pitanje">
        <!-- navbar -->
        <navbar></navbar>

        <div class="container" v-if="appState != 'loading-data'">
            <!-- counter pitanja -->
            <div class="counter">
                <counter></counter>
            </div>

            <!-- pitanje single -->
            <div class="p-single">
                <PitanjeSingle ref="pitanjeSingle"></PitanjeSingle>
            </div>
        </div>
        <div class="container loading" v-if="appState === 'loading-data'">
            <p>Učitavanje</p>
        </div>

        <!-- partneri -->
        <partneri  v-if="appState !== 'loading-data'"></partneri>

    </div>
</template>

<script>
import navbar from '../components/Navbar.vue'
import partneri from '../components/Partneri.vue'
import counter from '../components/PitanjeCounter.vue'
import PitanjeSingle from '../components/PitanjeSingle.vue'

export default {
    name: 'pitanje',
    data: function () {
        return {

        }
    },
    computed: {
        currentQuestionId () {
            return this.$store.state.currentQuestionId
        },
        questionId () {
            return this.$route.params.id
        },
        round () {
            return this.$store.getters.round
        },
        question () {
            return this.round.questions[this.questionId]
        },
        appState () {
            return this.$store.state.appState
        }
    },
    watch: {
        currentQuestionId (after, before) {
            if (before !== after) {
                if (after) {
                    this.$router.replace({ path: after })
                } else {
                    try {
                        let pitanjeSingle = this.$refs.pitanjeSingle
                        pitanjeSingle.sendAnswer(before)
                    } catch (error) {}
                    this.$router.replace({ name: 'prijava' })
                }
            }
        }
    },
    components: {
        navbar,
        partneri,
        counter,
        PitanjeSingle
    }
}
</script>

<style lang="scss" scoped>
.pitanje {
    padding-top: 14px;

    .counter {
        margin-bottom: 20px;
    }
    .p-single {
        margin-bottom: 20px;
    }
}
.loading {
    width: 100%;
    text-align: center;
}
@media only screen and (min-width: 800px) {
    .pitanje {
        max-width: 880px;
        margin: auto;
    }
}
</style>
